import React, {useState} from "react";
import {Alert, Button, Col, Container, Form, FormFeedback, FormGroup, Input, Jumbotron, Label} from "reactstrap";
import isEmail from 'validator/lib/isEmail'
import {InvestorFormSubmit} from "../api/investor-submit";

const InvestorNewUserRequest = () => {

    const defaultInvestorForm =  {
        firstName: null,
        lastName: null,
        email: null,
        title: null,
        phone: null,
        company: null,
        addressLine1: null,
        addressLine2: " ",
        city: null,
        state: null,
        country: null,
        reasons: [],
        accessReason: null,
        sevenElevenContact: null
    }

    const [investorForm, updateForm] = useState(defaultInvestorForm);
    const [response, updateResponse] = useState(null)

    const removeReason = (reasons, value) => {
        return reasons.filter(ele => ele !== value )
    }

    const displayReason5Options = () => {
        const userReason5 = investorForm.reasons.filter(reason => reason === "userReason5")
        console.log("userReason5 :" + userReason5);
        return (userReason5 && userReason5.length > 0) ? true: false;

    }

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        //console.log("onchange :" + name + "," + value + "," + type)
        if(type === 'checkbox'){
            const item = e.target.name;
            const isChecked = e.target.checked;
            let reasons = investorForm.reasons;
            if(isChecked){
                reasons.push(item)
            }
            else{
                reasons = removeReason(reasons,item)
            }
            updateForm(prevState => ({...prevState, reasons: reasons}))
        }
        else{
            updateForm((prevState) => {
                const newState = {...prevState, [name]: value}
                return newState;
            })
        }
    }

    const handleSubmit = () => {
        let valid = investorForm.firstName && investorForm.lastName && investorForm.email && investorForm.title
        valid = valid && investorForm.phone && investorForm.company && investorForm.addressLine1
        valid = valid && investorForm.city && investorForm.state && investorForm.country
        valid = valid && investorForm.reasons

        if(displayReason5Options()){
            valid = valid && investorForm.accessReason && investorForm.sevenElevenContact
        }

        console.log("Submit :" + valid)
        valid && InvestorFormSubmit(investorForm,updateResponse)();
    }

    const formRowTextInput = (label, inputId, inputName, type) => {
        const inputType = type ? type : "text";
        return(
            <FormGroup row>
                <Label for={inputId} sm={2}>{label}</Label>
                <Col sm={10}>
                    <Input type={inputType} name={inputName}
                           id={inputId}
                           placeholder={label} className="formOutline"
                           onChange={handleChange}
                           invalid={investorForm[inputName]  ? false : true}
                    />
                </Col>
                <FormFeedback>{label} cannot be blank</FormFeedback>
            </FormGroup>
        )

    }

    const formRowEmailInput = (label, inputId, inputName, type) => {
        const inputType = type ? type : "text";
        return(
            <FormGroup row>
                <Label for={inputId} sm={2}>{label}</Label>
                <Col sm={10}>
                    <Input type={inputType} name={inputName}
                           id={inputId}
                           placeholder={label} className="formOutline"
                           onChange={handleChange}
                           invalid={investorForm[inputName] && isEmail(investorForm[inputName]) ? false : true}
                    />
                </Col>
                <FormFeedback>{label} cannot be blank</FormFeedback>
            </FormGroup>
        )

    }

    const formRowReasonsCheckBox = (name, text) => {
        return (
            <FormGroup check row>
                <Label check sm={10}>
                    <Input type="checkbox" name={name} onChange={handleChange}/>{text}
                </Label>
            </FormGroup>
        )
    }

    const pageHeader = () => {
        return (
            <div>
                <Jumbotron style={{backgroundColor: '#03787C'}} >
                    <h1 className="display-6" style={{color:'white'}}>7-Eleven Debt Investor New User Request</h1>
                    <hr className="my-2"  />
                    <h6 style={{color:'white'}}> </h6>
                    <h6 style={{color:'white'}}></h6>
                </Jumbotron>
            </div>
        )
    }

    const displayForm  = () => {
        return (
            <div className="container-fluid">
                {pageHeader()}
                <Container className="themed-container" fluid={true}>
                    <Form>
                        {formRowTextInput("First Name","userFirstName", "firstName")}
                        {formRowTextInput("Last Name","userFirstName", "lastName")}
                        {formRowEmailInput("Business Email","userEmail", "email", "email")}
                        {formRowTextInput("Position Title","userTitle", "title")}
                        {formRowTextInput("Phone Number","userPhone", "phone", "number")}
                        {formRowTextInput("Company Name","userCompany", "company")}
                        {formRowTextInput("Address Line 1","userAddressLine1", "addressLine1")}
                        {formRowTextInput("Address Line 2","userAddressLine2", "addressLine2")}
                        {formRowTextInput("City/Town","userCity", "city")}
                        {formRowTextInput("State/Region/Province","userState", "state")}
                        {formRowTextInput("Country","userCountry", "country")}
                        {formRowTextInput("Zip/Postal Code","userZip", "zip")}



                        <FormGroup row>
                            <Label sm={10}>Reason for Requested Access</Label>
                        </FormGroup>
                        {formRowReasonsCheckBox("userReason1","Current holder or beneficial owner of outstanding 7-Eleven, Inc. Senior Unsecured Notes")}
                        {formRowReasonsCheckBox("userReason2","Bona fide prospective investors in 7-Eleven, Inc. Senior Unsecured Notes who are qualified institutional buyers (as defined in Rule 144A) or non-U.S. persons (as defined in Regulation S)")}
                        {formRowReasonsCheckBox("userReason3","Registered securities analyst (providing investment analysis with respect to the 7-Eleven, Inc. Senior Unsecured Notes)")}
                        {formRowReasonsCheckBox("userReason4","Market Maker affiliated with any initial purchaser of outstanding 7-Eleven, Inc. Senior Unsecured Notes")}
                        {formRowReasonsCheckBox("userReason5","Current vendor, supplier, trading partner, or financial institution that extends credit to 7-Eleven, Inc.")}
                        {displayReason5Options() ?
                            <div>
                                {formRowTextInput("Reason For Access","userAccessRequestedReason", "accessReason")}
                                {formRowTextInput("Primary 7-Eleven business contact","userprimary7ElevenContact", "sevenElevenContact")}
                            </div>
                            : ""
                        }
                        <p></p>
                        <FormGroup>
                            <Button  onClick={handleSubmit} style={{backgroundColor: '#03787C'}}>Submit</Button>
                        </FormGroup>
                    </Form>
                </Container>


                <hr className="my-2"  />
                <p className="text-muted">
                    Agreement: By applying for access to 7-Eleven, Inc.'s restricted financial information,
                    and each time you access such information, you (1) agree to strictly maintain the confidentiality
                    of such information; (2) agree to access it for internal credit review purposes only and for no other purpose;
                    (3) agree not to disclose it to any third party without 7-Eleven, Inc.’s prior written consent;
                    and (4) warrant that you have the express authority to bind your organization to obligations set forth above.
                    Furthermore, you acknowledge and agree that none of the information on 7-Eleven, Inc.’s restricted-access
                    Web site constitutes an offer to sell securities. Proceeding to access 7-Eleven, Inc.’s restricted financial
                    information will be deemed to be acceptance of the foregoing terms. If you do not agree with the foregoing,
                    you should not access the restricted financial information.
                </p>
            </div>
        )
    }

    const displaySubmitResponse = () => {
        return (
            <div className="container-fluid">
                {pageHeader()}
                <div>
                {response === "Success" ?
                    <div>
                        <Alert color="primary">Thank you for submission!!!</Alert>
                        <Alert color="info">You will be contacted after the request is processed</Alert>
                    </div>
                    :
                    <Alert color="danger">{response}</Alert>
                }
                </div>
            </div>
        )
    }

    return (
        response? displaySubmitResponse() : displayForm()
    )


}
 export default InvestorNewUserRequest;